import type { CatalogRide } from '@runkr/config/catalog'
import { assetUrl } from '../runnerPreview/previewLayout'
import { RunnerPreview } from '../runnerPreview/RunnerPreview'
import type { RunnerSlot } from '../runnerPreview/roster'
import { runnerName } from '../runnerPreview/roster'
import { rideImage } from '../wardrobe/rideImages'
import styles from './hub.module.css'
import ledge from './rideLedge.module.css'

/**
 * The equipped runner, large, standing on a stone ledge from the Sky Meadow kit
 * (`walk_stone_slab`: the walkway's left end, middle tile and right end). The hub background
 * (A-1) is the meadow parallax layers until the dedicated image arrives. The equipped ride
 * (T3.11) stands beside the runner in a round badge; a ride tried on in the shop (T3.9a) takes
 * its place, marked "Trying on".
 */
export function RunnerStage({
  slot,
  playerName,
  ride = null,
  trying = false,
}: {
  slot: RunnerSlot
  playerName: string
  ride?: CatalogRide | null
  /** `ride` is a try-on from the shop, not the equipped ride. */
  trying?: boolean
}) {
  const rideSrc = ride ? rideImage(ride.id) : null
  return (
    <div class={styles.stage}>
      <div class={styles.nameTag}>
        <span class={styles.nameTagName}>{playerName}</span>
        <span class={styles.nameTagRunner}>{runnerName(slot)}</span>
      </div>
      <div class={styles.stageRunner}>
        <RunnerPreview slot={slot} />
      </div>
      {ride && (
        <div
          class={`${ledge.rideBadge} ${trying ? ledge.rideTrying : ''}`}
          aria-label={`${trying ? 'Trying on' : 'Ride'}: ${ride.name}`}
        >
          <span class={ledge.rideDisc}>
            {rideSrc ? <img src={assetUrl(rideSrc)} alt="" draggable={false} /> : null}
          </span>
          <span class={ledge.rideName} data-testid="stage-ride">
            {ride.name}
          </span>
          {trying && (
            <span class={ledge.rideTryTag} data-testid="stage-try-on">
              Trying on
            </span>
          )}
        </div>
      )}
      <div class={ledge.ledge} aria-hidden="true">
        <span class={ledge.ledgeLeft} />
        <span class={ledge.ledgeMid} />
        <span class={ledge.ledgeRight} />
      </div>
    </div>
  )
}
